export * from 'server/models/BerthProfileResponse';


// WEBPACK FOOTER //
// ./data/models/BerthProfileResponse.ts